import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Grid } from '@mui/material';
import InventoryIcon from '@mui/icons-material/Inventory';
import AlarmOnIcon from '@mui/icons-material/AlarmOn';
import AvTimerIcon from '@mui/icons-material/AvTimer';
import ArrowCircleDownIcon from '@mui/icons-material/ArrowCircleDown';
import QueryStatsIcon from '@mui/icons-material/QueryStats';
import ArrowCircleUpIcon from '@mui/icons-material/ArrowCircleUp';
import AssessmentIcon from '@mui/icons-material/Assessment';
import AvgResolutionChart from './avg-resolution-chart';
import TicketsChart from './tickets-chart';
import BreachReasonsChart from './breach-reasons-chart';
import { clientAxios8080 } from '../../../configs/axios';
import { WrapperTotalTickets } from '../../mesa_servicio/total_tickets/styles';
import { getTotalTickets } from '../../../store/fuse/nivelService';
import '../styles.css';

const Estadisticas = () => {
  const dispatch = useDispatch();
  const [promedioResolucion, setPromedioResolucion] = useState(null);
  const [totalTickets, setTotalTickets] = useState(null);
  const [resolucionSieteDias, setResolucionSieteDias] = useState(null);
  const [resolucionSemanaAnterior, setResolucionSemanaAnterior] = useState(null);
  const [listTicketByMonthCurrent, setListTicketByMonthCurrent] = useState(null);
  const [chartData, setChartData] = useState([]);
  const dataNivelService = useSelector((state) => state.fuse?.nivelService);
  const initTotalTickets = () => dispatch(getTotalTickets());

  const [porcentajeMenosSemanaAnteriorValue, setPorcentajeMenosSemanaAnteriorValue] = useState(0);

  const darkMode = useSelector((state) => state?.fuse?.dashboard?.darkMode);

  async function getReportTicketMonthMultipleDetai() {
    try {
      const response = await clientAxios8080.get(
        '/ms-tickets/serviceLevels/getReportTicketMonthMultipleDetai'
      );
      const responseDataListTicketByMonthCurrent = response.data.data.listTicketByMonthCurrent;
      return responseDataListTicketByMonthCurrent;
    } catch (error) {
      console.error('Error fetching data:', error);
      throw error;
    }
  }

  async function getTicketPromedioResolucionAndTotal() {
    try {
      const response = await clientAxios8080.get(
        '/ms-tickets/serviceLevels/getTicketPromedioResolucionAndTotal'
      );

      const responseData = response.data.data;
      // Aquí puedes manejar la lógica para usar los datos de la respuesta como necesites
      const { promedio } = responseData;
      const { total } = responseData;

      // Por ahora, solo imprimiré los resultados, pero puedes hacer lo que necesites con estos valores
      console.log('Promedio:', promedio);
      console.log('Total:', total);

      // Puedes devolver los valores si es necesario
      return { promedio: promedio || 0, total };
    } catch (error) {
      console.error('Error fetching data:', error);
      // Puedes manejar el error según tus necesidades (lanzar una excepción, retornar un valor predeterminado, etc.)
      throw error;
    }
  }

  async function getStatusTicketBySevenDays() {
    try {
      const response = await clientAxios8080.get('/ms-tickets/serviceLevels/GetStatusTicketBySevenDays');
      const responseDataList = response.data.data;

      // Obtén el valor de promedio_mes y promedio_mes_anterior
      const promedioMes = responseDataList[0]?.promedio_mes || 0;
      const promedioMesAnterior = responseDataList[0]?.promedio_mes_anterior || 0;

      // Devuelve los valores
      return { promedioMes, promedioMesAnterior };
    } catch (error) {
      console.error('Error fetching data:', error);
      throw error;
    }
  }

  

  function formatHoursAndMinutes(hours) {
    const totalMinutes = hours * 60;
    const formattedHours = Math.floor(totalMinutes / 60);
    const formattedMinutes = Math.floor(totalMinutes % 60);

    return `${formattedHours} h ${formattedMinutes} m`;
  }

  useEffect(() => {
    const porcentajeMenosSemanaAnterior = () => {
      const valueToReturn =
        resolucionSieteDias !== null && resolucionSemanaAnterior !== null && resolucionSemanaAnterior !== 0
          ? ((resolucionSemanaAnterior - resolucionSieteDias) / resolucionSemanaAnterior) * 100
          : 0;
      setPorcentajeMenosSemanaAnteriorValue(valueToReturn);
    };
    porcentajeMenosSemanaAnterior();
  }, [resolucionSieteDias, resolucionSemanaAnterior]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const { promedio, total } = await getTicketPromedioResolucionAndTotal();
        const { promedioMes, promedioMesAnterior } = await getStatusTicketBySevenDays();
        const responseDataListTicketByMonthCurrent = await getReportTicketMonthMultipleDetai();
        const responseNivelService = await getTotalTickets();

        initTotalTickets();
        setChartData(responseNivelService);
        setPromedioResolucion(promedio);
        setTotalTickets(total);
        setResolucionSieteDias(promedioMes);
        setResolucionSemanaAnterior(promedioMesAnterior);
        setListTicketByMonthCurrent(responseDataListTicketByMonthCurrent);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchData();
  }, []); // Dependencia vacía para que se ejecute solo una vez al montar el componente

  return (
    <div style={{ flexGrow: 1 }}>
      <Grid container spacing={2} sx={{ marginBottom: '20px' }}>
        <Grid item lg={12} md={12} sm={12} xs={12} className="graphic-stats-container">
          <WrapperTotalTickets>
            <div className="section-tickets">
              {dataNivelService?.totalTickets?.map((data, index) => (
                <div className="w-1/4 justify-center" key={index}>
                  <strong>{data.nameTicket}</strong>
                  <div key={index} className="ticket-section" style={{ backgroundColor: data.colorTicket }}>
                    <strong className="white-text">{data.totalTicket}</strong>
                  </div>
                </div>
              ))}
            </div>
          </WrapperTotalTickets>
        </Grid>
        <Grid item lg={6} md={6} sm={12} xs={12} className="graphic-stats-container">
          <div
            className="max-w-full max-h-sm gap-0rounded-lg"
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              backgroundColor: darkMode ? 'rgb(17, 24, 39)' : 'white',
              height: '130px'
            }}
          >
            <div className="card-stats-chart-header h-100 flex items-center">
              <AssessmentIcon fontSize="large" />
              <h1 className="font-bold text-100 ml-10">Número de tickets del mes pasado:</h1>
            </div>
            <div className="card-stats-chart-header h-20 flex items-center">
              <h1 className="font-bold text-100 ml-10 text-blue-200">{totalTickets !== null ? `${totalTickets} tickets` : 'Cargando...'}</h1>
            </div>
          </div>
        </Grid>
        <Grid item lg={6} md={6} sm={12} xs={12} className="graphic-stats-container">
          <div
            className="max-w-full max-h-sm gap-0rounded-lg"
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              backgroundColor: darkMode ? 'rgb(17, 24, 39)' : 'white',
              height: '130px'
            }}
          >
            <div className="card-stats-chart-header h-100 flex items-center ml-10">
              <AlarmOnIcon fontSize="large" />
              <h2 className="font-bold ml-20">Tiempo de resolución promedio del mes pasado:</h2>
            </div>
            <div className="card-stats-chart-header h-20 flex items-center ">
              <h1 className="font-bold text-100 ml-10 text-green-500">
                {promedioResolucion !== null ? formatHoursAndMinutes(promedioResolucion) : 'Cargando...'}
              </h1>
            </div>
          </div>
        </Grid>
        <Grid item lg={6} md={6} sm={12} xs={12} className="graphic-stats-container">
          <div
            className="max-w-full max-h-sm gap-0rounded-lg"
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              backgroundColor: darkMode ? 'rgb(17, 24, 39)' : 'white',
            }}
          >
            <div className="card-stats-chart-header">
              <AvTimerIcon fontSize="large" />
              <h2 className="font-bold ml-10">Tiempo de resolución promedio del mes pasado:</h2>
            </div>

            <div className="card-stats-chart-header">
              <h1 className="font-bold text-200 ml-10">
                {resolucionSieteDias !== null ? formatHoursAndMinutes(resolucionSieteDias) : 'Cargando...'}
              </h1>
              <h3 className="font-bold text-200 ml-10"> </h3>
              <h3 className="font-bold text-200 ml-10"> </h3>
              <h3 className="font-bold text-200 ml-10"> </h3>
              <h3 className="font-bold text-200 ml-10"> </h3>
              <h3 className="font-bold text-200 ml-10"> </h3>
              <h3 className="font-bold text-200 ml-10"> </h3>
              <h3 className="font-bold text-200 ml-10"> </h3>
              <h3 className="font-bold text-200 ml-10"> </h3>
              <h3 className="font-bold text-200 ml-10"> </h3>
              <h3 className="font-bold text-200 ml-10"> </h3>
              {porcentajeMenosSemanaAnteriorValue !== null && (
                <h3 className="font-bold text-200 ml-10">
                  {porcentajeMenosSemanaAnteriorValue > 0 ? (
                    <ArrowCircleDownIcon fontSize="medium" />
                  ) : (
                    <ArrowCircleUpIcon fontSize="medium" />
                  )}
                  {` ${Math.abs(porcentajeMenosSemanaAnteriorValue || 0).toFixed(2)}% del mes antepasado`}
                </h3>
              )}
            </div>
            <div className="stats-chart-container">
              <AvgResolutionChart />
            </div>
          </div>
        </Grid>
        <Grid item lg={6} md={6} sm={12} xs={12} className="graphic-stats-container">
          <div
            className="max-w-full max-h-sm gap-0 rounded-lg"
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              backgroundColor: darkMode ? 'rgb(17, 24, 39)' : 'white',
            }}
          >
            <div className="card-stats-chart-header">
              <InventoryIcon fontSize="large" />
              <h1 className="font-bold text-200 ml-10">Tickets por día del mes pasado:</h1>
            </div>

            <div className="stats-chart-container">
              <TicketsChart />
            </div>
          </div>
        </Grid>
        <Grid item lg={12} md={12} sm={12} xs={12} className="graphic-stats-container">
          <div
            className="max-w-full max-h-sm gap-0 rounded-lg"
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              backgroundColor: darkMode ? 'rgb(17, 24, 39)' : 'white',
            }}
          >
            <div className="card-stats-chart-header">
              <QueryStatsIcon fontSize="large" />
              <h1 className="font-bold text-200 ml-10">Principales Causas de Incumplimiento</h1>
            </div>
            <div className="stats-chart-container">
              <BreachReasonsChart />
            </div>
          </div>
        </Grid>
      </Grid>
    </div>
  );
};

export default Estadisticas;
